import { render } from "./editTemplateEmailForInvitation.vue?vue&type=template&id=f63d3e16&scoped=true"
import script from "./editTemplateEmailForInvitation.vue?vue&type=script&lang=js"
export * from "./editTemplateEmailForInvitation.vue?vue&type=script&lang=js"

import "./editTemplateEmailForInvitation.vue?vue&type=style&index=0&id=f63d3e16&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63d3e16"]])

export default __exports__